var map = {
	"./account_management.ts": 12095,
	"./balances_management.ts": 73911,
	"./business_units.ts": 79722,
	"./decision_engine.ts": 79662,
	"./instant_retry.ts": 45536,
	"./payment_links.ts": 25674,
	"./payments_search.ts": 58050,
	"./payouts_management.ts": 65502,
	"./reports.ts": 13742,
	"./services.ts": 67153,
	"./transactions_approval.ts": 25312,
	"./treasury_analytics.ts": 56065,
	"./virtual_terminal.ts": 36641,
	"./webhooks.ts": 33235
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42640;